module.exports = __webpack_public_path__ + "img/abbie.604d9fa.png";